import { configureStore } from '@reduxjs/toolkit'
import appReducer from './data/appData'

export default configureStore({
  reducer: {
    appData: appReducer
  }
})